module.exports = __webpack_public_path__ + "img/UTKODA-16.f0c9549e.jpg";